/**
 * @constant {Object} COLORS
 * @description Defines color codes for various statuses and UI elements.
 */
export const COLORS = {
  /**
   * @property {string} ACTIVE - Represents the color for active status.
   * @value "#09A409" (Green)
   */
  ACTIVE: "#09A409",

  /**
   * @property {string} INACTIVE - Represents the color for inactive status.
   * @value "#dc2626" (Red)
   */
  INACTIVE: "#dc2626",

  /**
   * @property {string} MAINTENANCE - Represents the color for maintenance status.
   * @value "#FF9800" (Orange)
   */
  MAINTENANCE: "#FF9800",

  /**
   * @property {string} DEFAULT - Represents the default color for unspecified statuses.
   * @value "#6B7280" (Gray)
   */
  DEFAULT: "#6B7280",

  /**
   * @property {string} DARK_BLUE - Represents the dark blue theme color used in UI elements.
   * @value "#1a2142" (Dark Blue)
   */
  DARK_BLUE: "#1a2142",

  /**
   * @property {string} SIDEBAR_BG - Background color of the sidebar.
   * @value "#10163A" (Dark Blue)
   */
  SIDEBAR_BG: "#10163A",

  /**
   * @property {string} WHITE - Represents the color white.
   * @value "#ffffff" (White)
   */
  WHITE: "#ffffff",

  /**
   * @property {string} SIDEBAR_ACTIVE_TEXT - Color used for active sidebar text.
   * @value "#10163A" (Dark Blue)
   */
  SIDEBAR_ACTIVE_TEXT: "#10163A",

  /**
   * @property {string} BLUE - Represents the primary blue color used in UI elements.
   * @value "#3B82F6" (Blue)
   */
  BLUE: "#3B82F6",

  /**
   * @property {string} GREEN - Represents the primary green color used in UI elements.
   * @value "#22c55e" (Green)
   */
  GREEN: "#22c55e",

  /**
   * @property {string} SCANDAL - Light green shade, used for success background or subtle highlights.
   * @value "#dcfce7"
   */
  SCANDAL: "#dcfce7",

  /**
  * @property {string} EARLYDAWN - Light red/pinkish shade, typically used for error or warning backgrounds.
  * @value "#FFCCCB"
  */
  EARLYDAWN: "#FFCCCB",

  /**
   * @property {string} BEESWAX - Pale yellow shade used for cautionary highlights or informational notices.
   * @value "#fef9c3"
   */
  BEESWAX: "#fef9c3",

  /**
   * @property {string} GALLERY - Light gray color for borders, backgrounds, or disabled elements.
   * @value "#f0f0f0"
   */
  GALLERY: "#f0f0f0",

  /**
   * @property {string} JEWEL - Dark green shade for active/success elements or strong confirmation highlights.
   * @value "#166534"
   */
  JEWEL: "#166534",

  /**
   * @property {string} SEABUCKTHORN - Bright red tone.
   * @value "#FF0000"
   */
  SEABUCKTHORN: "#FF0000",

  /**
   * @property {string} KORMA - Rich brown/golden shade used for warning text or accents.
   * @value "#854d0e"
   */
  KORMA: "#854d0e",

  /**
   * @property {string} DOVEGRAY - Medium gray shade for subdued text or icons.
   * @value "#666"
   */
  DOVEGRAY: "#666",

  /**
   * @property {string} YELLOW - Bright yellow for warning messages or attention indicators.
   * @value "#ffd800"
   */
  YELLOW: "#ffd800",

  /**
   * @property {string} DatePickerColor - Background color used in date picker UI components.
   * @value "#ffffff" (White)
   */
  DatePickerColor: "#ffffff",

  /**
   * @property {string} RED - Strong red color, typically used for danger or destructive actions.
   * @value "#ff0000"
   */
  RED: "#ff0000",

  /**
   * @property {string} DARK_RED - Strong DARK RED color, typically used for danger or destructive actions.
   * @value "#ff0000"
   */
  DARK_RED: "#d32f2f",

  /**
   * @property {string} BLACK - Standard black color for text or high contrast elements.
   * @value "#000"
   */
  BLACK: "#000",

  /**
   * @property {string} ORANGE - Light orange color for text or high contrast elements.
   * @value "#ffa500"
   */
  PICKUPPENDING: "#ffa500",

  /**
   * @property {string} ORANGE - Light Transparent orange color for text or high contrast elements.
   * @value "#ffa50038"
   */
  PICKUPPENDING1: "#ffa50038",

  /**
   * @property {string} light gray - Light Transparent orange color for text or high contrast elements.
   * @value "#ffa50038"
   */
  LIGHT_GRAY: "#F5F5F5",

    /**
   * @property {string} light gray - Light Transparent ash color for text or high contrast elements.
   * @value "#ffa50038"
   */
  ASH: "#d4d4d4ad",

  /**
  * @property {string} light gray - Light Transparent ash color for text or high contrast elements.
  * @value "#ffa50038"
  */
  HOVER_ASH: "#d4d4d4",

  /**
   * @property {string} Navy blue - Light Transparent orange color for text or high contrast elements.
   * @value "#ffa50038"
   */
  NAVY_BLUE: "#10163a",

  /**
  * @property {string} LIght Greed - Light Transparent Green color for text or high contrast elements.
  * @value "#4CAF50"
  */
  LIGHT_GREEN: "#4CAF50",

  /**
* @property {string} Light Orange - Light Transparent orange color for text or high contrast elements.
* @value "#FFB677"
*/
  LIGHT_ORANGE: "#EC5800",

  /**
* @property {string} Light SAFFRON - Light Transparent SAFFRON color for text or high contrast elements.
* @value "#f7c594"
*/
  LIGHT_SAFFRON: "#f7c594",

  /**
  * @property {string} DARK SAFFRON - DARK SAFFRON color for text or high contrast elements.
  * @value "#e66102"
  */
  DARK_SAFFRON: "#e66102",
  /*
  * @property {string} TRANSPARANT COLOR - Light Transparent color for text or high contrast elements.
  * @value "#00000033"
  */
  TRANSPARANT_COLOR: "#00000033"
}